export enum PatientHeaderTitle {
  MEMBER_INFO = "MEMBER INFO",
  ADDRESS_INFO = "ADDRESS INFO",
  PHYSICIAN_INFO = "PCP INFO",
  PRIMARY_SUBSCRIBER_INFORMATION = "PRIMARY SUBSCRIBER INFORMATION",
}

export const PatientHeaderLabel = [
  { label: PatientHeaderTitle.MEMBER_INFO, fontWeight: 500 },
  { label: PatientHeaderTitle.ADDRESS_INFO, fontWeight: 500 },
  { label: PatientHeaderTitle.PHYSICIAN_INFO, fontWeight: 500 },
  { label: PatientHeaderTitle.PRIMARY_SUBSCRIBER_INFORMATION, fontWeight: 500 },
];

export enum PatientHeaderActionDispatchTypes {
  GET_PATIENT_HEADER_ERROR = "GET_PATIENT_HEADER_ERROR",
  GET_PATIENT_HEADER_INVOKE = "GET_PATIENT_HEADER_INVOKE",
  GET_PATIENT_HEADER_SUCCESS = "GET_PATIENT_HEADER_SUCCESS",
}